var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#233544",
    d: "M17.991 22C19.651 22 21 20.695 21 19.09V4.91C21 3.304 19.65 2 17.991 2H6.01C4.349 2 3 3.305 3 4.91v14.18C3 20.695 4.35 22 6.009 22H17.99ZM4.724 19.09V4.91c0-.686.576-1.243 1.285-1.243H17.99c.709 0 1.285.557 1.285 1.242v14.18c0 .687-.576 1.244-1.285 1.244H6.01c-.709 0-1.285-.557-1.285-1.243Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#233544",
    d: "M11.953 16.77H8.147c-.476 0-.862.372-.862.833 0 .46.386.833.862.833h3.806c.476 0 .861-.372.861-.833 0-.46-.385-.834-.861-.834ZM15.842 12.79H8.147c-.476 0-.862.372-.862.832 0 .461.386.834.862.834h7.695c.477 0 .862-.373.862-.834 0-.46-.385-.833-.862-.833ZM8.277 10.611l2.168-2.188 2.683 1.654a.884.884 0 0 0 1.104-.146l2.765-2.98a.814.814 0 0 0-.066-1.176.883.883 0 0 0-1.217.063l-2.277 2.454-2.662-1.642a.888.888 0 0 0-1.085.126L7.033 9.457a.814.814 0 0 0 .025 1.178.883.883 0 0 0 1.219-.024Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.6c8192f5aa69ba96d04d268bef3a8b30.svg";
export { ForwardRef as ReactComponent };